var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaptureInterviewFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.302,
    height: 12.558,
    viewBox: "0 0 11.302 12.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1671",
    "data-name": "Group 1671",
    transform: "translate(-1884 -455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bx-notepad",
    transform: "translate(1884 455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_747",
    "data-name": "Path 747",
    d: "M34.047,17.256H32.163V16H30.907v1.256H28.4V16H27.14v1.256H25.256A1.257,1.257,0,0,0,24,18.512V27.3a1.257,1.257,0,0,0,1.256,1.256h8.791A1.257,1.257,0,0,0,35.3,27.3V18.512A1.257,1.257,0,0,0,34.047,17.256Zm-9.129,10.4V18.2h9.427v9.453Z",
    transform: "translate(-24 -16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 8,
    height: 1,
    transform: "translate(1885.651 458.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 8,
    height: 1,
    transform: "translate(1885.651 460.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 4,
    height: 1,
    transform: "translate(1885.651 462.779)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureInterviewFeedback);
export default __webpack_public_path__ + "static/media/Capture Interview Feedback.a3ed434849b0846513ecbcbaaa680e79.svg";
export { ForwardRef as ReactComponent };